export enum OrchestratorStatusEnum {
    BookingCreated = "BOOKING_CREATED",
    QuoteCreated = "QUOTE_CREATED",
    Overbooking = "OVERBOOKING",
    CreateQuoteError = "CREATE_QUOTE_ERROR",
    GetStateError = "GET_STATE_ERROR",
    UpdateStateError = "UPDATE_STATE_ERROR",
}